// extracted by mini-css-extract-plugin
export default {"coachesContainer":"styles_coachesContainer__+bPKU","titleContainer":"styles_titleContainer__l-6b7"};